import styled from "styled-components";

export const RequestCardLabel = styled.p`
	opacity: 0.7;
	font-size: 80%;
`;
